import styled from 'styled-components/macro';
import { Link } from '~/components';

export const NavBar = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  background-color: ${({ theme }) => theme.dark4};
  bottom: 0;
  left: 0;
  z-index: 1;
  padding: 11px 50px 0 50px;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding: 11px 10px 0 10px;
  }
`;

export const NavBarTitle = styled.div`
  color: ${({ theme }) => theme.light};
  font-size: ${({ theme }) => theme.paragraph}px;
  font-family: ${({ theme }) => theme.primaryFontLight};
  text-transform: uppercase;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const NavBarOption = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: ${({ theme, competition }) =>
    competition === 1 ? theme.coral : theme.turquoise};
  background-color: ${({ theme, isActive }) => !isActive && theme.gray5};
  font-size: ${({ theme }) => theme.h5}px;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  border-style: none;
  margin-left: 11px;

  a {
    display: flex;
    align-items: center;
    font-size: ${({ theme }) => theme.h5}px;
    color: ${({ theme }) => theme.white};
    height: 100%;
    padding: 0 20px 0 20px;
    line-height: 49px;
  }

  svg {
    margin-left: 10px;
    polygon {
      fill: ${({ theme }) => theme.white};
    }
  }
`;

export const CloseNavBarOptionContainer = styled.div`
  flex: 1;
  display: ${({ shouldShow }) => (shouldShow ? 'flex' : 'none')};
  align-items: center;
  justify-content: flex-end;
  padding-left: 14px;
  transform-origin: 50% 50%;
`;

export const CloseLink = styled(Link)`
  line-height: 0;
  transition: all 0.3s;
  &:hover {
    transform: rotateZ(90deg);
  }
`;

export const Title = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.h5}px;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.white};
`;

export const Subtitle = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.primaryFont};
  font-size: ${({ theme }) => theme.label}px;
  color: ${({ theme }) => theme.white};
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    display: none;
  }
`;

export const TabLabel = styled.span``;

export const Grow = styled.div`
  flex-grow: 1;
  max-width: 129px;
`;
